<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Stock Taking</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="9">
            <v-data-table
              light
              dense
              :items-per-page="3000"
              :headers="headers"
              :items="orderItems"
              item-key="LineNum"
              hide-default-footer
              disable-sort
            >
              <template v-slot:item.Name="{ item }">
                <v-text-field
                  style="width: 350px"
                  class="orderInput"
                  single-line
                  dense
                  readonly
                  v-model="item.Name"
                ></v-text-field>
              </template>

              <template v-slot:item.available="{ item }">
                <div style="margin-right: ">{{ item.available }}</div>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <v-text-field
                  autocomplete="off"
                  type="number"
                  class="orderInput"
                  single-line
                  outlined
                  dense
                  v-model="item.Quantity"
                ></v-text-field>
              </template>

              <template v-slot:item.variance="{ item }">
                <div style="margin-left: 30px">
                  {{ item.Quantity - item.AvailableQty }}
                </div>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <v-autocomplete
              style="width: 350px"
              autocomplete="off"
              v-model="select"
              :isloading="isLoading"
              :items="products"
              :search-input.sync="searchProducts"
              @change="setOrderItem(select)"
              item-text="Name"
              item-value="id"
              cache-items
              class="mt-2"
              flat
              hide-no-data
              hide-details
              label="Search Product"
              outlined
              dense
            ></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-btn color="accent" @click="save" :loading="loader">
              <v-icon left>mdi-content-save</v-icon> Save
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    search: "",
    loader: false,
    excelFile: null,
    searchProducts: null,
    products: [],
    isLoading: false,
    select: null,
    orderItems: [],
    headers: [
      { text: "Product", value: "Name" },
      { text: "Available", value: "AvailableQty" },
      { text: "Correct Qty", value: "Quantity" },
      { text: "Variance", value: "variance" },
      { text: "Action", value: "action" },
    ],
  }),
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    querySelections(searchText) {
      const self = this;
      const url = "/search-products";
      const data = {
        searchText: searchText,
      };
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const data = {
        store_id: store_id,
        product_id: id,
      };

      const url = "/query-available-stock";
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const stockItem = res.ResponseData;
            // current item definition
            let currentItem = {};
            currentItem.Name = stockItem.product.Name;
            currentItem.o_i_t_m_s_id = stockItem.product.id;
            currentItem.LineNum = new Date().getTime();
            currentItem.AvailableQty = stockItem.AvailableQty;
            currentItem.Quantity = null;

            let initArray = [];

            initArray.push(currentItem);
            this.orderItems = [...this.orderItems, ...initArray];
            self.select = null;
            // get price api call
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    save() {
      const store_id = this.activeStore;
      const rows = this.orderItems;
      const data = {
        store_id: store_id,
        rows: rows,
      };
      const url = `/stock-take-adjustment`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          console.log(res, "stock response");
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.orderItems = [];
            this.$refs.snackbar.show("Stock Adjusted Successfully", "green");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>